export const APPROVAL_QUEUED_TEXT = 'Approval queued';
export const SEND_QUEUED_TEXT = 'Send queued';
export const SCHEDULING_QUEUED_TEXT = 'Scheduling queued';
export const RESCHEDULING_QUEUED_TEXT = 'Rescheduling queued';
